/* eslint-disable no-console */
import { register } from "register-service-worker";

import { ServiceWorkerWatchers } from "@/App/services/ServiceWorkerWatchers";
import Store from "@/App/store";

register(`${process.env.BASE_URL}service-worker.js`, {
  ready(registration: ServiceWorkerRegistration) {
    console.log(
      "App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB",
    );
    if ("Notification" in window) {
      Store.dispatch("PushNotification/init", registration, { root: true });
    }
  },
  registered() {
    console.log("Service worker has been registered.");
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New content is downloading.");
  },
  updated(registration: ServiceWorkerRegistration) {
    console.log("New content is available.");
    ServiceWorkerWatchers.newServiceWorkerWaiting(registration);
  },
  offline() {
    console.log("No internet connection found. App is running in offline mode.");
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  },
});

ServiceWorkerWatchers.newServiceWorkerActive(navigator.serviceWorker);
